import { createModule } from '../utils/factories';
import { resources } from '@/services/resources';
import indexManager from '../components/indexManager';
import crud from '../components/crud';
import processingTracker from '../components/processingTracker';
import relationManager from '../components/relationManager';

export default createModule({
  path: 'syntaxElement',
  resourceProfile: resources.syntaxElement,
  components: [crud, indexManager, processingTracker, relationManager],
  setup({ components }) {
    return {
      module: {},
      public: {
        ...components.$crud.public,
        ...components.$indexManager.public,
        ...components.$processingTracker.public,
        ...components.$relationManager.public,
      },
    };
  },
});
